var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeCheckSizesWeightfilled = function SvgTypeCheckSizesWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD833A",
    d: "M18.56 5.657 8.062 16.544c-.139.145-.304.26-.486.337a1.45 1.45 0 0 1-1.636-.337l-4.5-4.666a1.59 1.59 0 0 1-.439-1.1c0-.413.158-.81.44-1.1A1.47 1.47 0 0 1 2.5 9.22c.399 0 .78.164 1.062.456L7 13.245l9.438-9.79q.212-.217.487-.337a1.45 1.45 0 0 1 1.636.338c.139.144.25.316.325.505a1.61 1.61 0 0 1-.325 1.696"
  })));
};
export default SvgTypeCheckSizesWeightfilled;